/**
 * 生成占位图 data URI
 * 产品图用不同颜色区分品类
 */
const categoryColors = {
  formaldehyde: '#1ABC9C',
  organic: '#3498DB',
  inorganic: '#E67E22',
  custom: '#9B59B6'
}

export function getProductPlaceholder(id, category) {
  const color = categoryColors[category] || '#0A2859'
  const label = `Product #${id}`
  return createSvgDataUri(400, 400, color, label)
}

export function getBannerPlaceholder(id) {
  const colors = ['#0A2859', '#1A5276', '#154360']
  const color = colors[(id - 1) % colors.length]
  const label = `Banner ${id}`
  return createSvgDataUri(1920, 800, color, label)
}

export function getCategoryPlaceholder(key) {
  const color = categoryColors[key] || '#0A2859'
  return createSvgDataUri(600, 400, color, key.toUpperCase())
}

function createSvgDataUri(width, height, bgColor, label) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
    <defs>
      <linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style="stop-color:${bgColor};stop-opacity:0.8"/>
        <stop offset="100%" style="stop-color:${bgColor};stop-opacity:0.3"/>
      </linearGradient>
    </defs>
    <rect width="${width}" height="${height}" fill="url(#bg)"/>
    <rect width="${width}" height="${height}" fill="${bgColor}" opacity="0.15"/>
    <g transform="translate(${width/2},${height/2})">
      <circle cx="0" cy="-20" r="30" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="2"/>
      <text x="0" y="15" text-anchor="middle" font-family="Arial,sans-serif" font-size="16" fill="rgba(255,255,255,0.6)">${escapeXml(label)}</text>
    </g>
  </svg>`
  return 'data:image/svg+xml,' + encodeURIComponent(svg)
}

function escapeXml(str) {
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
}
